import { useApolloClient } from '@apollo/client';
import { useDataFetchingClient } from 'data-fetching-client';
import { ViewsManagementProvider } from 'customer-data-views-management/providers/ViewsManagementProvider';
import { mutationFieldPolicies, queryFieldPolicies } from 'customer-data-views-management/providers/fieldPolicies';
import { useAddTypePolicies } from 'marketing-platform-lib/hooks/useAddTypePolicies';

/**
 * This provider ensures that the DFC cache used by customer-data-views-management
 * is shared with the rest of framework-listing-lib.
 *
 * This is necessary for us to be able to reuse hooks from CDVM, like useFetchSingleView and useFetchPinnedViews,
 * outside of the PinnedViewsBar component subtree
 *
 * customer-data-views-management customizes their DFC cache. Requiring all downstream consumers to add a runtime dep
 * on CDVM, import its typePolicies, and add them to their DFC client constructions is unrealistic.
 * Instead we use addTypePolicies to inject them at runtime
 * https://www.apollographql.com/docs/react/caching/cache-configuration#customizing-type-policies
 * This needs to run before any CDVM queries return, or else the typePolicies will be bypassed
 *
 *  See also discussion here: https://git.hubteam.com/HubSpot/data-fetching-client/pull/270
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function PinnedViewsBarClientProvider(props) {
  const dfcClient = useDataFetchingClient();
  const apolloClient = useApolloClient();
  useAddTypePolicies({
    client: dfcClient,
    queryFieldPolicies,
    mutationFieldPolicies
  });
  return /*#__PURE__*/_jsx(ViewsManagementProvider, {
    dfcClient: dfcClient,
    apolloClient: apolloClient,
    children: props.children
  });
}